export default function SixDash() {
  return (
    <div className="flex gap-c16 justify-center relative z100 pointer-events-none mt-2">
      <span>_</span>
      <span>_</span>
      <span>_</span>
      <span>_</span>
      <span>_</span>
      <span>_</span>
    </div>
  );
}
